import type { ResizablePIPProps } from './ResizablePIPUI';
import ResizablePIPUI from './ResizablePIPUI';

export type { ResizablePIPProps } from './ResizablePIPUI';
export const resizablePipPadding = 15;

export const ResizablePIP = (props: ResizablePIPProps) => <ResizablePIPUI {...props} />;
